import { useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { FileImportDetailsType } from "api/models";
import { useGetFileImportList } from "api/queries/file-import/useGetFileImportList";
import DataTable from "components/organisms/DataTable/DataTable";
import PillTabs from "components/atoms/PillTabs/PillTabs";
import useTableQueryRequest from "hooks/useTableQueryRequest";
import getFileImportColumns from "./FileImportColumns";
import ImportDetailsDialog from "./ImportDetailsDialog/ImportDetailsDialog";
import "./FileImportHistory.scss";

export default function FileImportHistory() {
  const intl = useIntl();
  const [category, setCategory] = useState<string>("");
  const [searchParams, setSearchParams] = useSearchParams();

  const columns = useMemo(() => getFileImportColumns(intl), []);

  const { instance, loading, totalData } = useTableQueryRequest(useGetFileImportList, columns, {
    params: (tableInstance: any) => {
      const { sortBy } = tableInstance.state;
      return {
        ...(category && { status: category }),
        sort_by: sortBy?.[0] ? `date:${sortBy[0].desc ? "DESC" : "ASC"}` : "date:DESC",
      };
    },
  });

  const handleClickRow = (importHistory: FileImportDetailsType) => {
    searchParams.set("import", importHistory.file_import_job.id.toString());
    setSearchParams(searchParams);
  };

  return (
    <>
      <ImportDetailsDialog />
      <Card body className="shadow-none quote-container">
        <h3>
          <FormattedMessage id="settings.fileImportTools.fileImportHistory" defaultMessage="File Import History" />
        </h3>
        <DataTable
          withoutBody
          tableInstance={instance}
          totalData={totalData}
          isLoading={loading}
          draggable={false}
          onRowClick={(row) => handleClickRow(row.original)}
          autoPagination
          headerLeft={
            <div className="d-flex align-items-center mt-3">
              <PillTabs
                id="file-import-history-statuses"
                activeKey={category}
                onSelect={(eventKey: string) => {
                  searchParams.set("page", "1");
                  setSearchParams(searchParams);
                  setCategory(eventKey);
                }}
                tabItems={[
                  {
                    eventKey: "",
                    title: intl.formatMessage({
                      id: "settings.fileImportTools.fileImportHistory.all",
                      defaultMessage: "All",
                    }),
                  },
                  {
                    eventKey: "imported",
                    title: intl.formatMessage({
                      id: "settings.fileImportTools.fileImportHistory.imported",
                      defaultMessage: "Imported",
                    }),
                  },
                  {
                    eventKey: "incomplete",
                    title: intl.formatMessage({
                      id: "settings.fileImportTools.fileImportHistory.incompleted",
                      defaultMessage: "Incompleted",
                    }),
                  },
                ]}
              />
            </div>
          }
        />
      </Card>
    </>
  );
}
